import { Typography } from '@mui/material';
import { useEffect, useState } from 'react'
import { AdvisoryReportsDataTable } from './RegistrationAdvisorReportsDataTableColumns';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { RegistrationReportsRequest, Reports } from '../../../Component/Model/Dto/Advisory/Employee';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { ColumnSortOption } from '../../../Component/Model/Dto/ColumnSortOption';
import { AdvisoryService } from '../../../Component/Api/Advisory/AdvisoryService';
import { useRecoilValue } from 'recoil';
import { ClientRegistrationAtom } from '../../../State/Advisory/ClientRegistration.Atom';

export const RegistrationAdvisorReports = () => {
    const [reportData, setReportData] = useState<Reports[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>("");
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);
    const [filteredItemCount, setFilteredItemCount] = useState<number>(0);
    const [totalItemCount, setTotalItemCount] = useState<number>(0);

    const clientRegistration = useRecoilValue(ClientRegistrationAtom);

    const advisoryReportsSearchRequest: RegistrationReportsRequest = {
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        searchValue: searchValue,
        columnSortOptions: columnSortOptions,
        registrationId: clientRegistration.clientRegistrationId
    };

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
        setPageNumber(1);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setColumnSortOptions([sortOption]);
        setPageNumber(1);
    }

    useEffect(() => {
        fetchReports();
    }, [entriesPerPage,
        pageNumber,
        columnSortOptions,
        searchValue
    ]);

    const fetchReports = async () => {
        setIsLoading(true);
        try {
            const employeeResult = await AdvisoryService.searchRegistrationReports(advisoryReportsSearchRequest);
            setReportData(employeeResult.data.results);
            setFilteredItemCount(employeeResult.data.filteredItemsCount);
            setTotalItemCount(employeeResult.data.totalItemsCount);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    const reportsTable = AdvisoryReportsDataTable(reportData);

    return (
        <>
            <Typography variant="h4" style={{ paddingBottom: "20px" }}>
                Advisory Reports
            </Typography>

            <DataTable
                table={reportsTable}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemCount}
                totalItemsCount={totalItemCount}
                isLoading={isLoading}
                manualSorting={true}
                canSearch
                searchValueChanged={searchValueChanged}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                columnSortingChanged={columnSortingChanged} />
        </>
    )

}

